var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-hover", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var hover = ref.hover
          return [
            _c(
              "v-card",
              {
                staticClass: "ma-0 transition-swing pt-2",
                attrs: {
                  id: "exam",
                  "min-width": "256",
                  "min-height": "180",
                  elevation: hover ? 15 : 5
                }
              },
              [
                _c(
                  "v-card-title",
                  { staticClass: "headline mb-2" },
                  [
                    _c("h6", { staticStyle: { color: "#f78129" } }, [
                      _vm._v(_vm._s(_vm.exam.codigoCompra))
                    ]),
                    _c("v-spacer"),
                    _c("v-icon", { attrs: { color: "primary", small: "" } }, [
                      _vm._v("mdi-plus")
                    ])
                  ],
                  1
                ),
                _c(
                  "v-card-subtitle",
                  {
                    staticClass: "pb-1",
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "0.65rem"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatTitle")(_vm.exam.codigoStatus)) +
                        " - " +
                        _vm._s(_vm.switchDate(_vm.exam.codigoStatus)) +
                        " "
                    )
                  ]
                ),
                _c("v-card-text", [
                  _vm.exam.aviso
                    ? _c("span", { staticClass: "text" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("toUpperCase")(_vm.exam.aviso)) +
                            " "
                        )
                      ])
                    : _vm.exam.codigoStatus === 8
                    ? _c("span", { staticClass: "text" }, [
                        _vm._v(
                          " Seu Exame esta em Analise em nosso Laboratório, aguarde o resultado "
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }